module.exports = __webpack_public_path__ + "img/memoji-1.dffcf0e5.png";